'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var index = require('../Icon/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const PreferencesStatusWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-198gr9p-0"
})(["display:flex;align-items:center;justify-content:center;text-align:center;margin-bottom:2rem;flex-direction:", ";gap:4px;"], _ref => {
  let {
    emphasize
  } = _ref;
  return emphasize ? 'column' : 'row';
});
const PreferencesStatusIcon = styled__default["default"](index["default"]).withConfig({
  componentId: "sc-198gr9p-1"
})([""]);
const PreferencesStatusDescription = styled__default["default"].span.withConfig({
  componentId: "sc-198gr9p-2"
})(["display:flex;align-items:center;gap:8px;"]);
const PreferencesStatusLink = styled__default["default"].span.withConfig({
  componentId: "sc-198gr9p-3"
})(["font-weight:700;text-decoration:none;"]);

exports.PreferencesStatusDescription = PreferencesStatusDescription;
exports.PreferencesStatusIcon = PreferencesStatusIcon;
exports.PreferencesStatusLink = PreferencesStatusLink;
exports.PreferencesStatusWrapper = PreferencesStatusWrapper;
